import React from "react"
import { Field, useFormState } from "react-final-form"

import { Grid } from "@mui/material"
import { makeStyles } from "@mui/styles"

import { FilterGroup } from "./layout"
import { TextField } from "../../../atoms"
import { DEFAULT_FILTERS } from "../constants/defaultFilters"

const useStyles = makeStyles(() => ({
  dateRangeContainer: {
    width: "500px",
  },
  dateRangeDelimiter: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },
  sectionTitleStyle: {
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "16px !important",
    marginTop: "18px !important",
  },
}))

const SectionTitle = ({ sectionTitle }) => {
  const { sectionTitleStyle } = useStyles()

  if (!sectionTitle) return null

  return (
    <Grid container justifyContent={"start"} spacing={1}>
      <Grid item xs={10} className={sectionTitleStyle}>
        {sectionTitle}
      </Grid>
    </Grid>
  )
}

export const DateRangeFilter = ({ key, name, sectionTitle = "", titleFrom, titleTo }) => {
  const { dateRangeContainer, dateRangeDelimiter } = useStyles()
  const { initialValues } = useFormState()

  return (
    <FilterGroup className={dateRangeContainer} xs={12} {...{ key }}>
      <SectionTitle sectionTitle={sectionTitle} />
      <Grid container justifyContent="start" spacing={1}>
        <Grid item xs={5}>
          <Field name={`${name}From`}
                 initialValue={initialValues[`${name}From`] || (initialValues[DEFAULT_FILTERS] || {})[`${name}From`]}>
            {(field) => (
              <TextField
                {...field}
                value={field.input.value}
                onChange={(value) => {
                  if (!value.target.value && (initialValues[DEFAULT_FILTERS] || {})[`${name}From`]) {
                    value.target.value = (initialValues[DEFAULT_FILTERS] || {})[`${name}From`]
                  }

                  field.input.onChange(value.target.value)
                }}
                label={titleFrom}
                variant="filled"
                type="date"
                width="100%"
                InputLabelProps={{ shrink: true }}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={2}>
          <div className={dateRangeDelimiter}>—</div>
        </Grid>
        <Grid item xs={5}>
          <Field name={`${name}To`}>
            {(field) => (
              <TextField
                {...field}
                value={field.input.value}
                onChange={(value) => {
                  field.input.onChange(value.target.value)
                }}
                label={titleTo}
                variant="filled"
                type="date"
                width="100%"
                InputLabelProps={{ shrink: true }}
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </FilterGroup>
  )
}
